import React, { useState } from 'react';
import Card from './common/Card';
import Calendar from 'react-calendar';

// import 'react-calendar/dist/Calendar.css';
const Calender = () => {
    var options = { weekday: 'long', month: 'long', day: 'numeric', year: 'numeric' };

    const day = new Date().toLocaleDateString("en-US", options)

    const [value, onChange] = useState(new Date());

    return (
        <>
            <Card children=
                {<>
                    <h2 className='text-lg text-center font-bold p-2'>Calendar</h2>
                    <div className=' lg:flex items-center justify-evenly'>
                        <div className='container'>
                            {<p className='text-left text-kombuGreen font-bold p-4 '>{day}</p>}
                        </div>
                        <div className='container'>
                            <div className='container flex justify-center'>
                                <Calendar
                                    onChange={onChange}
                                    value={value}
                                />
                            </div>
                        </div>

                    </div>

                </>
                }
            />

        </>);
}

export default Calender;